// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Geist-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Geist-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Geist-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Geist-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Geist-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Geist-RegularItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/GeistMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/GeistMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/GeistMono-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/GeistMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/GeistMono-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/GeistMono-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/images/housetone.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --green: #5FBA8B;        /* your signature green */
  --green-light: #e6f4ee; /* for subtle fills */
  --ink: #0b0f0d;         /* near-black, not pure black */
  --white: #ffffff;
}


@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: bold;
}

@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
    font-weight: normal;
    font-style: bold;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
    font-weight: normal;
    font-style: italic;
}

.footer {

  position: relative;
  background-color: #FCF9F8;
  font-family: Geist;
  min-height: 70vh;
  max-height: 70vh;
/*  background: #d5d5d5; */
  /*border-top: 1px solid #000;*/
}


.footer-wash {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.3); /* increase this to make whitening obvious */
  pointer-events: none;
  z-index: 1;
}

/* keep actual content above base background but below/through wash as needed */
.filler-half,
.footer-inner {
  position: relative;
  z-index: 2;
}

.filler-half{
  min-height: 34vh;
}

.footer-inner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: center 45%;


  color: #000;
  /* border-top: 5px solid #000; */
  font-family: Geist;

  margin: 0 auto;
}

/* TICKER */

.ticker{
  position: relative;        /* keeps it in normal flow */
  display: block;

  width: 100%;
  overflow: hidden;
  /*border-top: 1px solid rgba(0,0,0,0.12);
  border-bottom: 1px solid rgba(0,0,0,0.12);*/
  padding: 12px 0;

  min-height: 10vh;
}

.ticker__track{
  display: flex;
  width: max-content;
  will-change: transform;
  animation: ticker-scroll 18s linear infinite;
    position: absolute;
      top: 30%;
}

.ticker__group{
  display: flex;
  align-items: center;
  gap: 18px;
  padding-right: 18px;
  white-space: nowrap;
}

.ticker__item{
  font-family: GeistMono;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0,0,0,0.78);
}

.ticker__sep{
  opacity: 0.5;
  font-weight: 800;
}

@keyframes ticker-scroll{
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce){
  .ticker__track{ animation: none; }
}



/* GRID */

.footer-grid {
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  min-height: 50vh;
}

.footer-grid > * {
  padding: 40px;
}

.footer-grid > *:not(:last-child) {
  border-right: 2px solid #000;
}

/* Statement */
.footer-statement h2 {
  font-size: 64px;
  line-height: 1.1;
  margin: 0;
  font-weight: 800;
}

.footer-statement p {
  margin-top: 20px;
  max-width: 420px;
  font-size: 16px;
  color: #333;
}

/* Nav */
.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: GeistMono;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 0.05em;
}

.footer-nav a {
  color: #242c29;
  text-decoration: none;
}

.footer-nav a:hover {
  text-decoration: underline;
  font-style: bold;
  color: #000;
}

/* Waitlist — halftone-safe (FINAL) */

.footer-waitlist h2 {
  font-family: Geist;
  white-space: nowrap;
  margin: 0 0 10px;
  font-size: 36px;
  font-style: bold;
  color: #0b0f0d; /* ink */
}

.footer-waitlist h3 {
  font-family: GeistMono;
  margin: 0 0 10px;
  font-size: 18px;
  font-style: normal;
  color: #0b0f0d; /* ink */
}

.footer-waitlist p {
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.4;
  color: #000;
}

/* Input wrapper */
.waitlist-input {
  display: flex;
  align-items: stretch;
  height: 44px;
  background: #ffffff;
  border: 1px solid #000;
}

/* Email / Phone field */
.waitlist-input input {
  flex: 1 1;
  padding: 0 12px;
  border: none;
  background: #ffffff;
  box-shadow: none !important;
  font-family: Geist;
  font-size: 15px;
  color: #000;
}

.waitlist-input input::placeholder {
  color: #000;
}

.waitlist-input input:focus {
  outline: none;
  background: #000;
  color: #d5d5d5;
}

.waitlist-input input:focus::placeholder {
  color: #ffffff;
}

/* Submit button */
.waitlist-input button {
  width: 44px;
  border: none;
  border-left: 1px solid #000;
  background: transparent;
  font-size: 18px;
  color: #0b0f0d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease, color 120ms ease;
}

.waitlist-input button:hover {
  background: #0b0f0d;
  color: #ffffff;
}

/* Toggle */
.waitlist-toggle {
  display: inline-flex;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.waitlist-toggle button {
  padding: 4px 8px;
  font-size: 11px;
  background: #fff;
  border: none;
  cursor: pointer;
  color: #000;
}

.waitlist-toggle button:not(:last-child) {
  border-right: 1px solid #000;
}

.waitlist-toggle button.active {
  background: #000;
  color: #fff;
}

/* Referral (hidden by default) */
.waitlist-referral {
  display: none;
  margin-top: 10px;
  font-size: 12px;
}

.waitlist-referral span {
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
}

.waitlist-referral code {
  display: block;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid #000;
  font-family: ui-monospace, monospace;
  font-size: 11px;
}

/* Success state */
.waitlist.success .waitlist-input,
.waitlist.success .waitlist-toggle {
  display: none;
}

.waitlist.success .waitlist-referral {
  display: block;
}



/* Newsletter — halftone-safe */

.footer-newsletter h3 {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
  color: #0b0f0d; /* ink */
}

.footer-newsletter p {
  margin: 0 0 18px;
  font-size: 13px;
  line-height: 1.4;
  color: #000;
}

/* Input wrapper */
.newsletter-input {
  display: flex;
  align-items: stretch;   /* ← important */
  background: #ffffff;
  color: #000;
  border: 1px solid #000;
  height: 44px;           /* ← define the box */
}

/* Email field */
.newsletter-input input {
  flex: 1 1;
  padding: 10px 12px;
  border: none;
  box-shadow: none !important;
  background: #FFF;
  font-size: 15px;
  color: #000;
}

.newsletter-input input::placeholder {
  color: #000;
}

.newsletter-input input:focus {
  outline: none;
  background: #000;
  color: #d5d5d5;
}

.newsletter-input input:focus::placeholder {
  color: #FFF;
}


/* Submit button */
.newsletter-input button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 100%;
  border: none;
  border-left: 1px solid #000;
  background: transparent;
  padding: 0;
  font-size: 18px;
  color: #0b0f0d;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
}

.newsletter-input button:hover {
  background: #0b0f0d;
  color: #ffffff;
}

/* Bottom bar */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 40px;
  font-family: GeistMono;
  font-size: 12px;
  max-height: 10vh;
}

.footer-links {
  display: flex;
  gap: 24px;
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* ============================
   PHONE: [flag][text][submit]
   Safe: does NOT cover/kill the submit button
   ============================ */

.waitlist-input--phone{
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #000;
}

/* LEFT square background + divider */
.waitlist-input--phone::before{
  content: "";
  grid-column: 1;
  background: #fff;
  border-right: 1px solid #000;
}

/* Middle: phone input lives here */
/* Phone number text input */
.phone2-container .react-tel-input input.form-control,
.phone2-container .react-tel-input input.phone2-input {
  font-family: Geist, sans-serif !important;
}


.waitlist-input--phone .phone2-container{
  grid-column: 2;
  position: relative;    /* anchor for flag dropdown */
  width: 100%;
  height: 100%;
}

/* Right: submit button lives here (never gets covered) */
.waitlist-input--phone > button[type="submit"]{
  grid-column: 3;
  width: 44px;
  height: 100%;
  border: none;
  border-left: 1px solid #000;
  background: transparent;
  font-size: 18px;
  color: #0b0f0d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease, color 120ms ease;
  z-index: 2;
}
.waitlist-input--phone > button[type="submit"]:hover{
  background: #0b0f0d;
  color: #fff;
}

/* Make library fill the middle cell */
.waitlist-input--phone .phone2-container .react-tel-input{
  width: 100%;
  height: 100%;
}

/* The actual text input: NO left padding for flag (flag is in its own column now) */
.waitlist-input--phone .phone2-container .form-control.phone2-input{
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: #fff !important;
  color: #000 !important;
  font: inherit !important;
  padding: 0 12px !important;
  border-radius: 0 !important;
}

/* Match your email focus style (only the middle turns black while typing) */
.waitlist-input--phone .phone2-container .form-control.phone2-input:focus,
.waitlist-input--phone .phone2-container .form-control.phone2-input:focus-visible{
  background: #000 !important;
  color: #d5d5d5 !important;
}
.waitlist-input--phone .phone2-container .form-control.phone2-input::placeholder{
  color: #000 !important;
}
.waitlist-input--phone .phone2-container .form-control.phone2-input:focus::placeholder{
  color: #fff !important;
}

/* FLAG DROPDOWN: pull it into the LEFT 44px column */
.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag{
  position: absolute !important;
  left: -44px !important;
  top: 0 !important;
  width: 44px !important;
  height: 100% !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  z-index: 3; /* above the ::before background */
}

.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag .selected-flag{
  width: 44px !important;
  height: 100% !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* caret triangle (visible) */
.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag .selected-flag .arrow{
  border-top: 5px solid #000 !important;
  border-left: 4px solid transparent !important;
  border-right: 4px solid transparent !important;
  margin-left: 6px !important;
}

/* ONLY the left square turns black when dropdown is OPEN */
.waitlist-input--phone:has(.flag-dropdown.open)::before{
  background: #000;
}
.waitlist-input--phone:has(.flag-dropdown.open)
  .flag-dropdown.phone2-flag .selected-flag .arrow{
  border-top-color: #fff !important;
}

/* Keep dropdown list above everything */
.waitlist-input--phone .phone2-container .country-list.phone2-dropdown{
  z-index: 99999 !important;
}

/* Hide the caret next to the flag (we use bg color as the indicator now) */
.waitlist-input--phone .phone2-container .selected-flag .arrow {
  display: none !important;
}

/* DEATH TO THE GREEN CAPSULE */
/* ==== Kill the green capsule from react-phone-input-2 bootstrap theme ==== */

/* 1) Remove any rounding + glow from anything inside the phone field */
.waitlist-input--phone .phone2-container,
.waitlist-input--phone .phone2-container .react-tel-input,
.waitlist-input--phone .phone2-container .react-tel-input * {
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 2) Specifically kill bootstrap focus glow on the input */
.waitlist-input--phone .phone2-container .form-control.phone2-input,
.waitlist-input--phone .phone2-container .form-control.phone2-input:focus,
.waitlist-input--phone .phone2-container .form-control.phone2-input:active,
.waitlist-input--phone .phone2-container .form-control.phone2-input:focus-visible {
  box-shadow: none !important;
  outline: none !important;
  border-radius: 0 !important;
  border: none !important;
}

.phone2-container .react-tel-input input.form-control,
.phone2-container .react-tel-input input.phone2-input {
  font-family: Geist, sans-serif !important;
  white-space: nowrap !important;
  margin: 0 !important;              /* inputs shouldn't have bottom margin */
  font-size: 15px !important;
  font-style: bold !important;      /* "bold" is not a valid font-style */
  font-weight: 800 !important;        /* use this for bold */
  color: #0b0f0d !important;
}

/* Mobile */
@media (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-grid > * {
    border-right: none;
    border-bottom: 1px solid #000;
  }

  .footer-grid > *:last-child {
    border-bottom: none;
  }

  .footer-statement h2 {
    font-size: 36px;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,SAAS,yBAAyB;EAClD,sBAAsB,EAAE,qBAAqB;EAC7C,cAAc,UAAU,+BAA+B;EACvD,gBAAgB;AAClB;;;AAGA;IACI,oBAAoB;IACpB;mEACgE;IAChE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB;mEAC6D;IAC7D,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB;mEACsE;IACtE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;mEACiE;IACjE,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB;oEACmE;IACnE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB,0BAA0B;EACxB,8BAA8B;AAChC;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC,EAAE,4CAA4C;EAClF,oBAAoB;EACpB,UAAU;AACZ;;AAEA,+EAA+E;AAC/E;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAAuD;EACvD,+BAA+B;;;EAG/B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;;EAElB,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,kBAAkB,SAAS,4BAA4B;EACvD,cAAc;;EAEd,WAAW;EACX,gBAAgB;EAChB;6CAC2C;EAC3C,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;IAC1C,kBAAkB;MAChB,QAAQ;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,gBAAgB,eAAe,EAAE;AACnC;;;;AAIA,SAAS;;AAET;EACE,aAAa;EACb,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,QAAQ;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc,EAAE,QAAQ;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;;AAIA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,QAAQ;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,oBAAoB,IAAI,gBAAgB;EACxC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY,YAAY,qBAAqB;AAC/C;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;iCAGiC;;AAEjC;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC,4BAA4B;AAC5B;;EAEE,yCAAyC;AAC3C;;;AAGA;EACE,cAAc;EACd,kBAAkB,KAAK,6BAA6B;EACpD,WAAW;EACX,YAAY;AACd;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oFAAoF;AACpF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,4EAA4E;AAC5E;;EAEE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,UAAU,EAAE,kCAAkC;AAChD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;AACA;;EAEE,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B,8EAA8E;;AAE9E,uEAAuE;AACvE;;;EAGE,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,2DAA2D;AAC3D;;;;EAIE,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;EAEE,yCAAyC;EACzC,8BAA8B;EAC9B,oBAAoB,eAAe,wCAAwC;EAC3E,0BAA0B;EAC1B,2BAA2B,OAAO,qCAAqC;EACvE,2BAA2B,SAAS,sBAAsB;EAC1D,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --green: #5FBA8B;        /* your signature green */\n  --green-light: #e6f4ee; /* for subtle fills */\n  --ink: #0b0f0d;         /* near-black, not pure black */\n  --white: #ffffff;\n}\n\n\n@font-face {\n    font-family: 'Geist';\n    src: url('../assets/fonts/Geist-Regular.woff2') format('woff2'),\n         url('../assets/fonts/Geist-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Geist';\n    src: url('../assets/fonts/Geist-Bold.woff2') format('woff2'),\n         url('../assets/fonts/Geist-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: bold;\n}\n\n@font-face {\n    font-family: 'Geist';\n    src: url('../assets/fonts/Geist-RegularItalic.woff2') format('woff2'),\n         url('../assets/fonts/Geist-RegularItalic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('../assets/fonts/GeistMono-Regular.woff2') format('woff2'),\n         url('../assets/fonts/GeistMono-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('../assets/fonts/GeistMono-Bold.woff2') format('woff2'),\n         url('../assets/fonts/GeistMono-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: bold;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('../assets/fonts/GeistMono-Italic.woff2') format('woff2'),\n         url('../assets/fonts/GeistMono-Italic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: italic;\n}\n\n.footer {\n\n  position: relative;\n  background-color: #FCF9F8;\n  font-family: Geist;\n  min-height: 70vh;\n  max-height: 70vh;\n/*  background: #d5d5d5; */\n  /*border-top: 1px solid #000;*/\n}\n\n\n.footer-wash {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.3); /* increase this to make whitening obvious */\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* keep actual content above base background but below/through wash as needed */\n.filler-half,\n.footer-inner {\n  position: relative;\n  z-index: 2;\n}\n\n.filler-half{\n  min-height: 34vh;\n}\n\n.footer-inner {\n  background-image: url('../assets/images/housetone.png');\n  background-position: center 45%;\n\n\n  color: #000;\n  /* border-top: 5px solid #000; */\n  font-family: Geist;\n\n  margin: 0 auto;\n}\n\n/* TICKER */\n\n.ticker{\n  position: relative;        /* keeps it in normal flow */\n  display: block;\n\n  width: 100%;\n  overflow: hidden;\n  /*border-top: 1px solid rgba(0,0,0,0.12);\n  border-bottom: 1px solid rgba(0,0,0,0.12);*/\n  padding: 12px 0;\n\n  min-height: 10vh;\n}\n\n.ticker__track{\n  display: flex;\n  width: max-content;\n  will-change: transform;\n  animation: ticker-scroll 18s linear infinite;\n    position: absolute;\n      top: 30%;\n}\n\n.ticker__group{\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding-right: 18px;\n  white-space: nowrap;\n}\n\n.ticker__item{\n  font-family: GeistMono;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0,0,0,0.78);\n}\n\n.ticker__sep{\n  opacity: 0.5;\n  font-weight: 800;\n}\n\n@keyframes ticker-scroll{\n  from { transform: translateX(0); }\n  to   { transform: translateX(-50%); }\n}\n\n@media (prefers-reduced-motion: reduce){\n  .ticker__track{ animation: none; }\n}\n\n\n\n/* GRID */\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: 2.5fr 1fr 1fr;\n  border-top: 2px solid #000;\n  border-bottom: 2px solid #000;\n  min-height: 50vh;\n}\n\n.footer-grid > * {\n  padding: 40px;\n}\n\n.footer-grid > *:not(:last-child) {\n  border-right: 2px solid #000;\n}\n\n/* Statement */\n.footer-statement h2 {\n  font-size: 64px;\n  line-height: 1.1;\n  margin: 0;\n  font-weight: 800;\n}\n\n.footer-statement p {\n  margin-top: 20px;\n  max-width: 420px;\n  font-size: 16px;\n  color: #333;\n}\n\n/* Nav */\n.footer-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-family: GeistMono;\n  text-transform: uppercase;\n  font-size: 13px;\n  letter-spacing: 0.05em;\n}\n\n.footer-nav a {\n  color: #242c29;\n  text-decoration: none;\n}\n\n.footer-nav a:hover {\n  text-decoration: underline;\n  font-style: bold;\n  color: #000;\n}\n\n/* Waitlist — halftone-safe (FINAL) */\n\n.footer-waitlist h2 {\n  font-family: Geist;\n  white-space: nowrap;\n  margin: 0 0 10px;\n  font-size: 36px;\n  font-style: bold;\n  color: #0b0f0d; /* ink */\n}\n\n.footer-waitlist h3 {\n  font-family: GeistMono;\n  margin: 0 0 10px;\n  font-size: 18px;\n  font-style: normal;\n  color: #0b0f0d; /* ink */\n}\n\n.footer-waitlist p {\n  margin: 0 0 14px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #000;\n}\n\n/* Input wrapper */\n.waitlist-input {\n  display: flex;\n  align-items: stretch;\n  height: 44px;\n  background: #ffffff;\n  border: 1px solid #000;\n}\n\n/* Email / Phone field */\n.waitlist-input input {\n  flex: 1;\n  padding: 0 12px;\n  border: none;\n  background: #ffffff;\n  box-shadow: none !important;\n  font-family: Geist;\n  font-size: 15px;\n  color: #000;\n}\n\n.waitlist-input input::placeholder {\n  color: #000;\n}\n\n.waitlist-input input:focus {\n  outline: none;\n  background: #000;\n  color: #d5d5d5;\n}\n\n.waitlist-input input:focus::placeholder {\n  color: #ffffff;\n}\n\n/* Submit button */\n.waitlist-input button {\n  width: 44px;\n  border: none;\n  border-left: 1px solid #000;\n  background: transparent;\n  font-size: 18px;\n  color: #0b0f0d;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 120ms ease, color 120ms ease;\n}\n\n.waitlist-input button:hover {\n  background: #0b0f0d;\n  color: #ffffff;\n}\n\n/* Toggle */\n.waitlist-toggle {\n  display: inline-flex;\n  border: 1px solid #000;\n  margin-bottom: 10px;\n}\n\n.waitlist-toggle button {\n  padding: 4px 8px;\n  font-size: 11px;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  color: #000;\n}\n\n.waitlist-toggle button:not(:last-child) {\n  border-right: 1px solid #000;\n}\n\n.waitlist-toggle button.active {\n  background: #000;\n  color: #fff;\n}\n\n/* Referral (hidden by default) */\n.waitlist-referral {\n  display: none;\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.waitlist-referral span {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\n.waitlist-referral code {\n  display: block;\n  padding: 6px 8px;\n  background: #fff;\n  border: 1px solid #000;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n}\n\n/* Success state */\n.waitlist.success .waitlist-input,\n.waitlist.success .waitlist-toggle {\n  display: none;\n}\n\n.waitlist.success .waitlist-referral {\n  display: block;\n}\n\n\n\n/* Newsletter — halftone-safe */\n\n.footer-newsletter h3 {\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0b0f0d; /* ink */\n}\n\n.footer-newsletter p {\n  margin: 0 0 18px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #000;\n}\n\n/* Input wrapper */\n.newsletter-input {\n  display: flex;\n  align-items: stretch;   /* ← important */\n  background: #ffffff;\n  color: #000;\n  border: 1px solid #000;\n  height: 44px;           /* ← define the box */\n}\n\n/* Email field */\n.newsletter-input input {\n  flex: 1;\n  padding: 10px 12px;\n  border: none;\n  box-shadow: none !important;\n  background: #FFF;\n  font-size: 15px;\n  color: #000;\n}\n\n.newsletter-input input::placeholder {\n  color: #000;\n}\n\n.newsletter-input input:focus {\n  outline: none;\n  background: #000;\n  color: #d5d5d5;\n}\n\n.newsletter-input input:focus::placeholder {\n  color: #FFF;\n}\n\n\n/* Submit button */\n.newsletter-input button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 100%;\n  border: none;\n  border-left: 1px solid #000;\n  background: transparent;\n  padding: 0;\n  font-size: 18px;\n  color: #0b0f0d;\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease;\n}\n\n.newsletter-input button:hover {\n  background: #0b0f0d;\n  color: #ffffff;\n}\n\n/* Bottom bar */\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 40px;\n  font-family: GeistMono;\n  font-size: 12px;\n  max-height: 10vh;\n}\n\n.footer-links {\n  display: flex;\n  gap: 24px;\n}\n\n.footer-links a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.footer-links a:hover {\n  text-decoration: underline;\n}\n\n/* ============================\n   PHONE: [flag][text][submit]\n   Safe: does NOT cover/kill the submit button\n   ============================ */\n\n.waitlist-input--phone{\n  display: grid;\n  grid-template-columns: 44px 1fr 44px;\n  height: 44px;\n  background: #fff;\n  border: 1px solid #000;\n}\n\n/* LEFT square background + divider */\n.waitlist-input--phone::before{\n  content: \"\";\n  grid-column: 1;\n  background: #fff;\n  border-right: 1px solid #000;\n}\n\n/* Middle: phone input lives here */\n/* Phone number text input */\n.phone2-container .react-tel-input input.form-control,\n.phone2-container .react-tel-input input.phone2-input {\n  font-family: Geist, sans-serif !important;\n}\n\n\n.waitlist-input--phone .phone2-container{\n  grid-column: 2;\n  position: relative;    /* anchor for flag dropdown */\n  width: 100%;\n  height: 100%;\n}\n\n/* Right: submit button lives here (never gets covered) */\n.waitlist-input--phone > button[type=\"submit\"]{\n  grid-column: 3;\n  width: 44px;\n  height: 100%;\n  border: none;\n  border-left: 1px solid #000;\n  background: transparent;\n  font-size: 18px;\n  color: #0b0f0d;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 120ms ease, color 120ms ease;\n  z-index: 2;\n}\n.waitlist-input--phone > button[type=\"submit\"]:hover{\n  background: #0b0f0d;\n  color: #fff;\n}\n\n/* Make library fill the middle cell */\n.waitlist-input--phone .phone2-container .react-tel-input{\n  width: 100%;\n  height: 100%;\n}\n\n/* The actual text input: NO left padding for flag (flag is in its own column now) */\n.waitlist-input--phone .phone2-container .form-control.phone2-input{\n  width: 100% !important;\n  height: 100% !important;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: #fff !important;\n  color: #000 !important;\n  font: inherit !important;\n  padding: 0 12px !important;\n  border-radius: 0 !important;\n}\n\n/* Match your email focus style (only the middle turns black while typing) */\n.waitlist-input--phone .phone2-container .form-control.phone2-input:focus,\n.waitlist-input--phone .phone2-container .form-control.phone2-input:focus-visible{\n  background: #000 !important;\n  color: #d5d5d5 !important;\n}\n.waitlist-input--phone .phone2-container .form-control.phone2-input::placeholder{\n  color: #000 !important;\n}\n.waitlist-input--phone .phone2-container .form-control.phone2-input:focus::placeholder{\n  color: #fff !important;\n}\n\n/* FLAG DROPDOWN: pull it into the LEFT 44px column */\n.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag{\n  position: absolute !important;\n  left: -44px !important;\n  top: 0 !important;\n  width: 44px !important;\n  height: 100% !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  z-index: 3; /* above the ::before background */\n}\n\n.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag .selected-flag{\n  width: 44px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* caret triangle (visible) */\n.waitlist-input--phone .phone2-container .flag-dropdown.phone2-flag .selected-flag .arrow{\n  border-top: 5px solid #000 !important;\n  border-left: 4px solid transparent !important;\n  border-right: 4px solid transparent !important;\n  margin-left: 6px !important;\n}\n\n/* ONLY the left square turns black when dropdown is OPEN */\n.waitlist-input--phone:has(.flag-dropdown.open)::before{\n  background: #000;\n}\n.waitlist-input--phone:has(.flag-dropdown.open)\n  .flag-dropdown.phone2-flag .selected-flag .arrow{\n  border-top-color: #fff !important;\n}\n\n/* Keep dropdown list above everything */\n.waitlist-input--phone .phone2-container .country-list.phone2-dropdown{\n  z-index: 99999 !important;\n}\n\n/* Hide the caret next to the flag (we use bg color as the indicator now) */\n.waitlist-input--phone .phone2-container .selected-flag .arrow {\n  display: none !important;\n}\n\n/* DEATH TO THE GREEN CAPSULE */\n/* ==== Kill the green capsule from react-phone-input-2 bootstrap theme ==== */\n\n/* 1) Remove any rounding + glow from anything inside the phone field */\n.waitlist-input--phone .phone2-container,\n.waitlist-input--phone .phone2-container .react-tel-input,\n.waitlist-input--phone .phone2-container .react-tel-input * {\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* 2) Specifically kill bootstrap focus glow on the input */\n.waitlist-input--phone .phone2-container .form-control.phone2-input,\n.waitlist-input--phone .phone2-container .form-control.phone2-input:focus,\n.waitlist-input--phone .phone2-container .form-control.phone2-input:active,\n.waitlist-input--phone .phone2-container .form-control.phone2-input:focus-visible {\n  box-shadow: none !important;\n  outline: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n}\n\n.phone2-container .react-tel-input input.form-control,\n.phone2-container .react-tel-input input.phone2-input {\n  font-family: Geist, sans-serif !important;\n  white-space: nowrap !important;\n  margin: 0 !important;              /* inputs shouldn't have bottom margin */\n  font-size: 15px !important;\n  font-style: bold !important;      /* \"bold\" is not a valid font-style */\n  font-weight: 800 !important;        /* use this for bold */\n  color: #0b0f0d !important;\n}\n\n/* Mobile */\n@media (max-width: 900px) {\n  .footer-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-grid > * {\n    border-right: none;\n    border-bottom: 1px solid #000;\n  }\n\n  .footer-grid > *:last-child {\n    border-bottom: none;\n  }\n\n  .footer-statement h2 {\n    font-size: 36px;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
